import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { AsideBarComponent } from './components/aside-bar/aside-bar.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonsModule } from '../commons/commons.module';



@NgModule({
  declarations: [
    NavBarComponent,
    AsideBarComponent,
    ChangePasswordComponent
  ],
  imports: [
    CommonsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    SharedModule // to remove
  ],
  exports: [
    NavBarComponent,
    AsideBarComponent,
    ChangePasswordComponent
  ]
})
export class CoreModule { }
